import { CircularProgress } from '@mui/material';
import { Grid } from '@mui/system';
import { NO_BACKUP_CODES_AVAILABLE } from 'common/constants/login';
import { BackupCodesInfoProps } from './types';
import { Item, ItemCode, ItemsContainer, NoBackupCodesText } from '../BackupCodes.styles';

const BackupCodesInfo = ({
  backupCodes,
  disabledGenerate = false,
  isGeneratingBackupCodes = false,
  isModal = false,
}: BackupCodesInfoProps) => (
  <ItemsContainer container justifyContent="center" alignItems="center">
    {disabledGenerate && (
      <Grid container justifyContent="center" alignItems="center">
        <NoBackupCodesText>{NO_BACKUP_CODES_AVAILABLE}</NoBackupCodesText>
      </Grid>
    )}

    {!disabledGenerate && (backupCodes.length === 0 || isGeneratingBackupCodes) ? (
      <Grid container justifyContent="center" alignItems="center">
        <CircularProgress />
      </Grid>
    ) : (
      !disabledGenerate
        && backupCodes.map(code => (
          <Item key={`bk-codes-${code}`} xs={12} sm={isModal ? 6 : 'auto'} item>
            <ItemCode>{code}</ItemCode>
          </Item>
        ))
    )}
  </ItemsContainer>
);

export default BackupCodesInfo;
